import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import Breadcrumb from '../../components/Breadcrumb';

interface AuditEntry {
  id: string;
  actorUserId: string;
  action: string;
  scopeType: string | null;
  scopeId: string | null;
  payload: unknown;
  createdAt: number;
}

export default function AdminAudit() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'audit'],
    queryFn: () => api.get<{ entries: AuditEntry[] }>('/admin/audit?limit=200'),
  });

  return (
    <div>
      <Breadcrumb items={[{ label: 'Admin' }, { label: 'Audit log' }]} />
      <h1 className="mb-8 font-heading text-3xl font-bold text-dark">Audit log</h1>

      {isLoading ? (
        <div className="text-sm text-gray-500">Načítám…</div>
      ) : (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-50 text-xs uppercase tracking-wide text-gray-600">
                <th className="px-4 py-3 text-left">Kdy</th>
                <th className="px-4 py-3 text-left">Actor</th>
                <th className="px-4 py-3 text-left">Akce</th>
                <th className="px-4 py-3 text-left">Scope</th>
                <th className="px-4 py-3 text-left">Detail</th>
              </tr>
            </thead>
            <tbody>
              {data?.entries.map((e) => (
                <tr key={e.id} className="border-t border-gray-100">
                  <td className="px-4 py-3 text-xs text-gray-500">
                    {new Date(e.createdAt * 1000).toLocaleString('cs-CZ')}
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-600">{e.actorUserId.slice(0, 8)}</td>
                  <td className="px-4 py-3 font-mono text-xs">{e.action}</td>
                  <td className="px-4 py-3 text-xs text-gray-500">
                    {e.scopeType ? `${e.scopeType}:${e.scopeId?.slice(0, 8)}` : '—'}
                  </td>
                  <td className="px-4 py-3 text-xs font-mono text-gray-600">
                    {e.payload ? JSON.stringify(e.payload).slice(0, 80) : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
